import './theme_kovanen.scss'
import ITheme from '../ITheme';

export default class ThemeKovanen implements ITheme {
    id: string = "kovanen";
    cssClassName: string = "theme_kovanen";
    dark: boolean = false;
    menuRight: boolean = true;
    menuDark: boolean = true;
    toolbarDark: boolean = true;
    vuetifyTheme: any = {
        primary: '#ffcb31',
        secondary: '#00ff00',
        accent: '#ffcb31',
        warning: '#ffcb31'
    }
}
